export { default as Main } from './main/Main';
export { default as Footer } from './footer/Footer';